import { Button } from "components/Button/Button";
import { IconCollection } from "components/Icon/IconCollection";
import IconButton from "components/IconButton";
import { Popover } from "components/Popover/Popover";
import "./TableDensitySelector.scss";
import { TableDensity } from "./tableUtils";

const DENSITY_OPTIONS: { value: TableDensity; label: string }[] = [
    { value: "regular", label: "Comfortable" },
    { value: "medium", label: "Cozy" },
    { value: "high", label: "Compact" },
];

type TableDensitySelectorProps = {
    density: TableDensity;
    setDensity: (density: TableDensity) => void;
};

/**
 * A standard, non-distracting toolbar control (single icon that opens a small
 * popover) letting the user pick the row density of a table. Mirrors
 * {@link TableColumnsSelector}: presentational only — the chosen value is
 * persisted per table by the parent RecordTable via its settings key.
 */
const TableDensitySelector = ({ density, setDensity }: TableDensitySelectorProps) => (
    <div className="tableDensitySelector">
        <Popover
            trigger={<IconButton icon={IconCollection.formatLineSpacing} />}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            contentClassName="table-density__popover"
        >
            <div className="table-density__options" role="radiogroup" aria-label="Row density">
                {DENSITY_OPTIONS.map((opt) => (
                    <Button
                        key={opt.value}
                        variation={opt.value === density ? "primary" : "clear"}
                        label={opt.label}
                        ariaLabel={opt.label}
                        onClick={() => setDensity(opt.value)}
                    />
                ))}
            </div>
        </Popover>
    </div>
);

export default TableDensitySelector;
